import React from "react";
import { Box, Tooltip } from "@material-ui/core";
import { get } from "lodash";
import UserProfileWidget from "../../../widgets/UserProfileWidget";

const TargetAssignedTo = colProps => {
  return (
    <td>
      <Tooltip title={get(colProps, "dataItem.assignedTo", "")}>
        <Box display="flex" alignItems="center">
          <UserProfileWidget
            userId={get(colProps, "dataItem.assignedUser.userId", "")}
            firstName={get(colProps, "dataItem.assignedUser.firstName", "")}
            lastName={get(colProps, "dataItem.assignedUser.lastName", "")}
            url={get(colProps, "dataItem.assignedUser.profileImage", "")}
          />
          <span className="truncate-txt">
            {get(colProps, "dataItem.assignedTo", "")}
          </span>
        </Box>
      </Tooltip>
    </td>
  );
};

export default TargetAssignedTo;
